import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { MyaccountCredentialsService } from 'src/app/service/myaccount/myaccount-credentials.service';
import {
  CHANGE_PASSWORD,
  MyaccountFeaturesConfigService,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import { MyaccountInfoService } from 'src/app/service/myaccount/myaccount-info.service';
import { AsmCheckerService } from 'src/app/utility/asm-checker.service';

@Component({
  selector: 'app-myaccount-your-credentials',
  templateUrl: './myaccount-your-credentials.component.html',
  styleUrls: ['./myaccount-your-credentials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, AsyncPipe, TranslatePipe],
})
export class MyaccountYourCredentialsComponent implements OnInit {
  myaccountYourCredentials$: Observable<any>;
  myaccountYourCredentialsLoaded$: Subscription;
  isASMEnabled = false;

  activeCountry$: Observable<string> = this.countryService.getActive();

  isChangePasswordEnabled$: Observable<any> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, CHANGE_PASSWORD)
    )
  );

  constructor(
    protected cms: CmsService,
    private mycredentials: MyaccountCredentialsService,
    private asmUser: AsmCheckerService,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private myAccountInfo: MyaccountInfoService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.myaccountYourCredentialsLoaded$ = combineLatest([
      this.isAccountPage$(),
      this.getMyAccountCredentials(),
      this.myAccountInfo.isMyAccountInfoDetailsLoaded,
    ]).subscribe(([accountPage, myAccountCredential, isMyAccountInfoDetailsLoaded]) => {
      if (accountPage && myAccountCredential && isMyAccountInfoDetailsLoaded) {
        this.myaccountYourCredentials$ = of(myAccountCredential);
        this.mycredentials.isYourCredentialsDetailsLoaded.next(true);
      }
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });

    this.isASMEnabled = this.asmUser.isAsmEnabled();
  }

  isAccountPage$(): Observable<boolean> {
    return this.cms
      .getCurrentPage()
      .pipe(map((currentPage) => currentPage && currentPage.label.includes('/my-account')));
  }

  private getMyAccountCredentials(): Observable<any> {
    return this.mycredentials.getYourCredentials();
  }

  ngOnDestroy() {
    if (this.myaccountYourCredentialsLoaded$) {
      this.myaccountYourCredentialsLoaded$.unsubscribe();
    }
  }
}
